import { makeApiCall } from "../makeApiCall";
import { AdminService_URL, ThirdPartyService_URL } from "../Url";

export const RackReduxActions = {
  ADD_UPDATE_RACK_SUCCESS: "ADD_UPDATE_RACK_SUCCESS",
  ADD_UPDATE_RACK_FAILURE: "ADD_UPDATE_RACK_FAILURE",
  EXPORT_RACK_SUCCESS: "EXPORT_RACK_SUCCESS",
  EXPORT_RACK_FAILURE: "EXPORT_RACK_FAILURE",
};

////? Add or update Rack service

export function addRackSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: RackReduxActions.ADD_UPDATE_RACK_SUCCESS,
      payload: props,
    });
  };
}

export function addRackFailureAction(error) {
  return {
    type: RackReduxActions.ADD_UPDATE_RACK_FAILURE,
    payload: error,
  };
}

export function addRackThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/addOrUpdateRackForOrder?orderId=${props.orderId}&rackNumber=${props.rackNumber}`;

  return makeApiCall(
    postUrl,
    addRackSuccessAction,
    addRackFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

////? Add or update Rack service

export function exportRackSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: RackReduxActions.EXPORT_RACK_SUCCESS,
      payload: props,
    });
  };
}

export function exportRackFailureAction(error) {
  return {
    type: RackReduxActions.EXPORT_RACK_FAILURE,
    payload: error,
  };
}

export function exportRackThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/exportActiveOrderInRack${
    props.warehouseId && `?warehouseId=${props.warehouseId}`
  }`;

  return makeApiCall(
    postUrl,
    exportRackSuccessAction,
    exportRackFailureAction,
    "POST",
    null,
    reqHeader,
    props.history
  );
}
